/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSOClientId ?? 'bdd1ac55-b84e-4947-a8be-160adbde5bcf',
    authority: process.env.REACT_APP_SSOAuthority ?? 'https://login.microsoftonline.com/68fac18b-9e76-4cef-b2b7-2c51b521cb94',
    redirectUri: process.env.REACT_APP_SSORedirectUri ?? 'https://lori-uat.oryxenergies.com',
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // use 'localStorage' if you want to persist authenfication in the browser
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowRedirectInIframe: true, // Allows silent SSO across tabs
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: (level: any, message: any, containsPii: any) => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            console.log(message);
            break;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read', 'Group.Read.All'],
  prompt: 'select_account',
};
